import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { a as ChildBox } from './Tile.styles-N6j8NPOo.js';
import { u as useTileContext } from './TileContext-CI56_oXw.js';

const TileSection = ({
  children,
  noPadding = false,
  padding = 'medium',
  paddingBlockStart,
  paddingBlockEnd,
  paddingInlineStart,
  paddingInlineEnd,
  ...restProps
}) => {
  const {
    direction
  } = useTileContext();
  return /*#__PURE__*/React__default.createElement(ChildBox, _extends({}, restProps, {
    $direction: direction,
    padding: noPadding ? 'none' : padding,
    paddingBlockStart: paddingBlockStart,
    paddingBlockEnd: paddingBlockEnd,
    paddingInlineStart: paddingInlineStart,
    paddingInlineEnd: paddingInlineEnd
  }), children);
};

export { TileSection as T };
//# sourceMappingURL=TileSection-BqiNZVsO.js.map
